<title mat-dialog-title>{{ title | t }}</title>
<mat-dialog-content>
  <div [innerHTML]="sanitizeHTML(message | t)"></div>
  <ng-container *ngIf="config.typeDeleteToConfirm || config.confirmationInput">
    <p>{{ confirmationLabel | t }}</p>
    <mat-form-field class="example-full-width">
      <mat-label>{{ confirmationPlaceholder | t }}</mat-label>
      <input matInput [(ngModel)]="enteredConfirmationText" />
    </mat-form-field>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <!-- [color] and [attr.color] both needed for buttons below for all SnColorPalette colors to work -->
  <button
    mat-button
    [color]="cancelButton.color"
    [attr.color]="cancelButton.color"
    (click)="cancel()"
  >
    {{ cancelButton.text | t }}
  </button>
  <button
    mat-button
    [color]="alternativeButton.color"
    [attr.color]="alternativeButton.color"
    (click)="alternative()"
    type="button"
    *ngIf="alternativeButton"
  >
    {{ alternativeButton.text | t }}
  </button>
  <button
    mat-button
    [disabled]="!isConfirmEnabled()"
    [color]="confirmButton.color"
    [attr.color]="confirmButton.color"
    (click)="confirm()"
  >
    {{ confirmButton.text | t }}
  </button>
</mat-dialog-actions>
